import objectToStyle from '../../utils/objectToStyle.js';
import safeJSONParse from '../../utils/safeJSONParse.js';
import { updateBrowserControlState } from '../../external_node_modules/@wg/web2clientapi/browser/updateBrowserControlState.js';
import { writable } from '../../external_node_modules/svelte/store/index.mjs.js';
import { BRIDGE_EVENT_TYPES } from '../../constants/bridgeEvents.js';
import { EVENTS } from '../../constants/events.js';
import { PURCHASE_STATUSES } from '../../constants/purchaseStatuses.js';
import settings from '../../settings.js';
import { addSearchParamsToUrl, buildUrl } from '../../utils/buildUrl.js';
import { disableBodyOverflow } from '../../utils/disableBodyOverflow.js';
import { log } from '../../utils/logger.js';
import App from './App.svelte.js';

const defaultStyles = {
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    width: '100%',
    height: '100%',
    'z-index': 2147483608,
    'background-color': 'rgba(0, 0, 0, 0.7)',
};
const defaultAttributes = {
    allowtransparency: '1',
    frameborder: '0',
    seamless: '1',
};
function createPurchaseConfirmation (productCode, events, quantity, customStorefrontName, customFields = {}) {
    return new Promise((resolve) => {
        const url = addSearchParamsToUrl(buildUrl(settings.webPurchaseConfirmationIframeUrl, {
            productCode,
            language: settings.language,
            backendUrl: settings.backendUrl,
            storefrontName: customStorefrontName || settings.storefrontName,
            quantity: quantity || 1,
        }), customFields);
        const styles = objectToStyle(Object.assign({}, defaultStyles, settings.webPurchaseConfirmationIframeStyles));
        const attributes = Object.assign({}, defaultAttributes, settings.webPurchaseConfirmationIframeAttributes, {
            src: url,
        });
        const isLoading = writable(true);
        events.emit(EVENTS.OVERLAY_VISIBILITY, { visible: true });
        const app = new App({
            target: document.body,
            props: {
                isLoading,
                attributes,
                styles,
                setLoading,
                closeApplicationAndResolve,
            },
        });
        function setLoading(visible) {
            log('[frame] Set loading state', visible);
            isLoading.update((state) => (visible));
        }
        function messageEventHandler(e) {
            const payload = safeJSONParse(e.data);
            log('[frame] Handle message from iframe', payload);
            switch (payload.type) {
                case BRIDGE_EVENT_TYPES.APPLICATION_LOADED: {
                    setLoading(false);
                    break;
                }
                case BRIDGE_EVENT_TYPES.CLOSE_APPLICATION: {
                    closeApplicationAndResolve(PURCHASE_STATUSES.CANCELLED);
                    break;
                }
                case BRIDGE_EVENT_TYPES.PURCHASE_STATUS: {
                    const event = payload;
                    if (event.productCode === productCode) {
                        closeApplicationAndResolve(event.purchaseStatus, event.errorCode);
                    }
                    break;
                }
                case BRIDGE_EVENT_TYPES.ESCAPE_BUTTON: {
                    const event = payload;
                    updateBrowserControlState(event.handled);
                    break;
                }
            }
        }
        function closeApplicationAndResolve(purchaseStatus = PURCHASE_STATUSES.CANCELLED, errorCode) {
            log('[frame] Close application and resolve with status =', purchaseStatus, 'errorCode =', errorCode);
            disableBodyOverflow(false);
            updateBrowserControlState(false);
            window.removeEventListener('message', messageEventHandler);
            events.emit(EVENTS.OVERLAY_VISIBILITY, { visible: false });
            app.$destroy();
            resolve({ purchaseStatus: purchaseStatus, errorCode: errorCode });
        }
        window.addEventListener('message', messageEventHandler);
        // ESC button is drawn by the Game,
        // so if we need to hide the button, we call this method
        updateBrowserControlState(true);
    });
}

export { createPurchaseConfirmation as default };
//# sourceMappingURL=index.js.map
